import Image from "next/image"
import Link from "next/link"
import { cn } from "@/lib/utils"

interface FooterProps {
  className?: string
  variant?: "default" | "golden" | "dark"
}

export function Footer({ className, variant = "default" }: FooterProps) {
  const isGolden = variant === "golden"
  const isDark = variant === "dark"

  const logoSrc = isDark ? "/brand/Logo-Star-light.svg" : "/brand/Logo-Star_dark.svg"

  const brandColor = isDark
    ? "var(--brand-moon)"
    : isGolden
      ? "var(--brand-night-sky)"
      : "var(--gold)"

  const bodyColor = isDark
    ? "rgba(255, 242, 189, 0.7)"
    : isGolden
      ? "var(--brand-cliff)"
      : "var(--text-muted)"

  const dimColor = isDark
    ? "rgba(255, 242, 189, 0.5)"
    : isGolden
      ? "var(--brand-calm-mist)"
      : "var(--text-dim)"

  return (
    <footer
      className={cn(
        isDark
          ? "bg-[#010101]"
          : isGolden
            ? "bg-[var(--brand-moon)] py-12"
            : "bg-[var(--bg-page)] py-12",
        className
      )}
    >
      {/* Constellation image — dark variant only */}
      {isDark && (
        <Image
          src="/brand/footer-constellations.png"
          alt=""
          width={1920}
          height={960}
          className="block h-auto w-full"
          style={{ display: "block" }}
        />
      )}

      {!isGolden && !isDark && <div className="divider-gold mx-auto mb-12 max-w-xs" />}

      <div
        className={cn("py-12")}
      >
        <div className="mx-auto max-w-5xl px-4 sm:px-6">
          <div className="flex flex-col items-center gap-3 text-center">
            <div className="flex items-center gap-2.5">
              <Image
                src={logoSrc}
                alt=""
                width={20}
                height={20}
                className="h-5 w-5"
              />
              <span
                className="text-xs font-medium tracking-[0.2em] uppercase"
                style={{ color: brandColor }}
              >
                Lumensis
              </span>
            </div>
            <p className="text-sm" style={{ color: bodyColor }}>
              Your mind, illuminated.
            </p>
            <p className="text-xs" style={{ color: dimColor }}>
              Your raw data is never stored permanently. Your results are yours.
            </p>
            <div
              className="mt-2 flex items-center gap-4 text-xs"
              style={{ color: dimColor }}
            >
              <Link href="/science" className="transition-colors hover:opacity-70">
                Science
              </Link>
              <span>&middot;</span>
              <Link href="/patterns" className="transition-colors hover:opacity-70">
                Thinking Styles
              </Link>
              <span>&middot;</span>
              <Link href="/terms" className="transition-colors hover:opacity-70">
                Terms
              </Link>
              <span>&middot;</span>
              <Link href="/privacy" className="transition-colors hover:opacity-70">
                Privacy
              </Link>
            </div>
            <p className="mt-4 text-xs" style={{ color: dimColor }}>
              &copy; Lumensis 2026
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
